<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <form v-on:submit="createWorkflowGroup">
              <div class="col-md-5">
                <h5>Information</h5>
                <br>
                <form-text ref="name" label="Name" name="name" v-model="workflowGroup.name" validation="required"></form-text>
                <v-select placeholder="Workfow(s)" multiple :options="workflows" validation="required" :value.sync="write_workflows" label="name" name="workflows"></v-select>              
              </div>
              <br>
              <div class="col-md-5">
                <div class="form-group">
                    <button type="submit" class="btn btn-success btn-lg">Create</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div><!-- /.col-md-9 -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import FormText from '../../elements/Form/FormText'
import FormTextArea from '../../elements/Form/FormTextArea'
import ActiveFormCheckbox from '../../elements/Form/ActiveFormCheckbox'
import FormSelect from '../../elements/Form/FormSelect'
import database from '../../webmaster/Database/database'
import firebase from 'firebase'
import axios from 'axios'
import vSelect from 'vue-select'

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'createworkflowgroup',
  components:{
    'form-text':FormText,
    'form-checkbox':ActiveFormCheckbox,
    'form-textarea':FormTextArea,
    'form-select':FormSelect,
    vSelect
  },
  data () {
    return {
      workflowGroup: {
        name: '',
      },
      workflows: [],
      write_workflows: [],
    }
  },
  created:function(){
    this.fetchAll()
  },
  methods: {
    createWorkflowGroup:function(e){
      e.preventDefault()
      var self = this
      let promises = [];

      for (let child in this.$refs) promises.push(this.$refs[child].$validator.validateAll());

      Promise.all(promises).then(this.$validator.validateAll()).then(() => { 
        var curOrgId = self.$store.state.usermain.curOrg.id
        var newWorkflowGroupKey = database.getDb().ref().child('orgs').child(curOrgId).child('workflow_groups').push().key;
        var updates = {};

        var workflowKeys = [];

        self.write_workflows.forEach(function (workflow) {
          workflowKeys.push(workflow[".key"])
        })
        updates['/orgs/' + curOrgId + '/workflow_groups/' + newWorkflowGroupKey] = {
          "name": self.workflowGroup.name,
          "workflow_keys": workflowKeys,
        };

        /*database.getRef("/orgs/" + curOrgId + "/defaultworkflowgroup").once('value').then(defWorkflowGroupSnapchat => {
          if (defWorkflowGroupSnapchat.val() == null) {
            updates['/orgs/' + curOrgId + '/defaultworkflowgroup'] = newWorkflowGroupKey
          }

          database.getDb().ref().update(updates, function(){
            self.$router.push('/admin/workflowgroups')
          });
        }) */

        database.getDb().ref().update(updates, function(){
          self.$router.push('/admin/workflowgroups')
        });
      }, () => {});
    },
    fetchAll: function() {
      this.fetchWorkflows()
    },
    fetchWorkflows:function(){
      //Get all workflows
      var workflowsRef = '/orgs/' + this.$store.state.usermain.curOrg.id + '/meta_workflows'

      this.$bindAsArray('workflows', database.getRef(workflowsRef));
    },
  }
}
</script>

<!-- Add "scoped" group to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// CreateWorkflowGroup.vue?5b940bff